export default __webpack_public_path__ + "static/media/img6.a0c806c2.jpg";